@if (control) {
  <div class="container">
    <span>
      <mat-label [class.error]="required && control.touched && control.invalid">
        {{ label | translate }}
      </mat-label>
      @if (required && control.enabled) {
        *
      }
    </span>
    <mat-selection-list
      (selectionChange)="onChange($event)"
      [formControl]="control"
      [multiple]="isMultiple"
      [required]="required"
    >
      @for (option of options; track option) {
        <mat-list-option checkboxPosition="before" [value]="option.id">
          {{ option.name | translate }}
        </mat-list-option>
      }
    </mat-selection-list>
    @if (!control.pristine) {
      @for (error of control.errors | errorKeys; track error) {
        <mat-error>
          {{ error | translate }}
        </mat-error>
      }
    }
  </div>
}
